<template>
  <page class="bg-color">
    <template v-for="(item, index) in invoicesList">
      <div class="invoice-box" :key="'box_' + index">
        <div class="invoice-title">增值税电子普通发票</div>
        <div class="invoice-list">
          <em>发票抬头</em>
          <span>{{item.title}}</span>
        </div>
        <div class="invoice-list invoice-list--line">
          <em>发票内容</em>
          <span>{{item.content}}</span>
        </div>
        <div class="invoice-list">
          <em>发票金额</em>
          <span>￥{{item.price}}</span>
        </div>
        <div class="invoice-list">
          <em>开票日期</em>
          <formatData :date="item.date * 1000" fmt="yyyy-MM-dd"/>
        </div>
      </div>
      <div class="invoice--buttom" :key="'btn_' + index">
        <div class="buttom download" @click="downloadInvoice(item.invoiceUrl)">发票下载</div>
        <div class="buttom" @click="$router.push({name: 'Invoice-email',query:{orderSn: item.orderSn,invoiceId: item.invoiceId}})">发送电子邮件</div>
      </div>
    </template>
  </page>
</template>

<script>
import formatData from '@/components/formatData'
export default {
  components: {
    formatData
  },
  props: {},
  data () {
    return {
      invoicesList: []
    }
  },
  computed: {
  },
  methods: {
    downloadInvoice(url) {
      window.location = url
      // const a = document.createElement('a')
      // a.href = url
      // a.target = '_self'
      // a.style.display = 'none'
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
    }
  },
  created() {
    // this.$service.orderInvoices({
    //   orderSn: this.$route.query.orderSn
    // }).then(res => {
    //   this.invoicesList = res.data
    // })
  }
}
</script>

<style lang="stylus" scoped>
.invoice-box
  background #ffffff
  border-radius 14px
  width 355px
  margin 10px auto 0
  padding 13px 0
  .invoice-title
    height 44px
    line-height 44px
    text-align center
    color #FC4C00
    font-size 14px
    position relative
  .invoice-title:after,
  .invoice-title:before
    border 1px solid #FC4C00
    border-radius 100%
    content ''
    display block
    position absolute
    z-index 1
  .invoice-title:after
    width 94px
    height 44px
    left 130px
    top 0
  .invoice-title:before
    width 82px
    height 34px
    left 136px
    top 5px
  .invoice-list
    height 26px
    line-height 26px
    font-size 14px
    padding 0 10px
    margin 0 5px
  .invoice-list--line
    border-bottom 1px solid #E5E5E5
    padding-bottom 7px
    margin-bottom 7px
  .invoice-list em
    color #999999
    float left
    font-style normal
  .invoice-list span
    color #333333
    float right
.invoice--buttom
  height 45px
  line-height 45px
  width 335px
  margin 0 auto
  display flex
  padding 10px 0 20px 0
  .buttom
    flex 1
    background #fff
    border-radius 5px
    font-size 16px
    text-align center
    color #FC4C00
  .download
    background #FC4C00
    color #ffffff
    margin-right 20px

</style>
